import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { getIsAutomaticReplyEnabled, getSendRepliesOutsideOrgEnabled, getSendRepliesToContactsOnlyEnabled, } from '../selectors/getStoreProperties';
/**
 * Utility function to get external audience
 * @returns external audience status of type ExternalAudience
 */
export default function getExternalAudience() {
    var isEnterpriseUser = !isConsumer();
    var isAutomaticReplyEnabled = getIsAutomaticReplyEnabled();
    if (!isAutomaticReplyEnabled) {
        return 0 /* None */;
    }
    var sendRepliesOutsideOrgEnabled = getSendRepliesOutsideOrgEnabled();
    if (isEnterpriseUser && !sendRepliesOutsideOrgEnabled) {
        return 0 /* None */;
    }
    var sendRepliesToContactsOnlyEnabled = getSendRepliesToContactsOnlyEnabled();
    return sendRepliesToContactsOnlyEnabled ? 1 /* Known */ : 2 /* All */;
}
//# sourceMappingURL=getExternalAudience.js.map